import React from "react";
import "../css/leaders-insights.css";
import Navbar from "../Navbar";
import { Link } from "react-router-dom";

export default function LeadersInsights() {
  return (
    <>
      <Navbar />
      <div className="insights-section">
        <div className="insights-wrapper">
          <div className="profile-wrapper">
            <Link to="/oliver-johnson">
            <img
              src="./images/Oliver-Johnson.jpg"
              alt="Person 1"
              className="profile-image"
            />
            </Link>
            <div className="profile-content">
              <div className="profile-title">
              <Link to="/oliver-johnson">
                <h1> Driving Innovation and Fostering Collaboration in the Global
                 Industry</h1>
                 </Link>
              </div>
              <div className="profile-subtitle">
                <p>Oliver Johnson,Founder | LoomCraft Heritage</p>
                
              </div>
              
              <div className="profile-description">
            
                <p>LoomCraft Heritage When I started LoomCraft Heritage, I wasn’t just launching a company—I was reviving a legacy...</p>
               
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>June 25, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>

          <div className="profile-wrapper">
            <Link to="/fernando-perez"></Link>
            <img
              src="./images/Fernando-perez.jpg"
              alt="Person 2"
              className="profile-image"
            />
            <div className="profile-content">
              <div className="profile-title">
              <Link to="/fernando-perez">
                <h1>Building Communities, Brick By Brick</h1>
                </Link>
              </div>
              <div className="profile-subtitle">
                <p>Founder, Pérez & Sons Construction</p>
                
              </div>
             
              <div className="profile-description">
              
                <p>When I founded Pérez & Sons Construction, I wasn’t just starting a business—I was building on a legacy of hard work, integrity, and community values...</p>
               
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>May 24, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>

          <div className="profile-wrapper">
            <Link to="/susan-brown">
            <img
              src="./images/Susan-brown.jpg"
              alt="Person 3"
              className="profile-image"
            />
            </Link>
            <div className="profile-content">
              <div className="profile-title">
              <Link to="/susan-brown">
                <h1> Sharing Stories. Changing Lives.</h1>
                </Link>
              </div>
              <div className="profile-subtitle">
                <p>Susan Brown,CFO, Zing Foods and Produce</p>
                
              </div>
              
              <div className="profile-description">
                <p>When I stepped into the role of Chief Financial Officer at Zing Foods and Produce, I knew I was embarking on a journey that combined two of my greatest passions</p>
                
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>May 24, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="advertisement-section"></div>
      </div>
    </>
  );
}
